@if (isLoading) {
<div class="loading-overlay">
  <mat-progress-spinner
    class="spinner"
    [diameter]="100"
    mode="indeterminate"
    color="primary"
  ></mat-progress-spinner>
</div>
}
